var _rect, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6, _circle4, _circle5, _circle6, _circle7, _path7, _path8, _circle8, _path9, _path10, _path11, _circle9, _circle10, _circle11, _path12, _path13, _circle12, _circle13, _circle14, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 7,
    fill: "#250D3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4036 33.2728C29.4036 33.9369 29.4114 34.5189 29.427 35.0189C29.4504 35.5111 29.4739 35.9369 29.4973 36.2962C29.5286 36.6556 29.5637 36.9564 29.6028 37.1986C29.6497 37.4408 29.6965 37.6439 29.7434 37.808V37.8548H26.9309V37.808C26.9778 37.6439 27.0208 37.4408 27.0598 37.1986C27.1067 36.9564 27.1418 36.6556 27.1653 36.2962C27.1965 35.9369 27.22 35.5111 27.2356 35.0189C27.259 34.5267 27.2708 33.9447 27.2708 33.2728V25.6439C27.2708 24.9798 27.259 24.4017 27.2356 23.9095C27.22 23.4095 27.1965 22.9798 27.1653 22.6205C27.1418 22.2611 27.1067 21.9603 27.0598 21.7181C27.0208 21.4681 26.9778 21.2611 26.9309 21.097V21.0501L27.4231 21.097C27.5715 21.1126 27.7356 21.1244 27.9153 21.1322C28.1028 21.1322 28.2942 21.1322 28.4895 21.1322C28.7942 21.1322 29.2043 21.097 29.72 21.0267C30.2434 20.9486 30.9075 20.9095 31.7122 20.9095C32.4622 20.9095 33.1536 21.0111 33.7864 21.2142C34.427 21.4173 34.9817 21.7142 35.4504 22.1048C35.9192 22.4955 36.2825 22.9759 36.5403 23.5462C36.8059 24.1087 36.9387 24.7494 36.9387 25.4681C36.9387 26.0306 36.8645 26.554 36.7161 27.0384C36.5754 27.515 36.3723 27.9486 36.1067 28.3392C35.8489 28.7298 35.5364 29.0775 35.1692 29.3822C34.802 29.679 34.3918 29.929 33.9387 30.1322L38.052 35.9095C38.2551 36.1986 38.4426 36.4486 38.6145 36.6595C38.7942 36.8705 38.9622 37.054 39.1184 37.2103C39.2825 37.3587 39.4387 37.4837 39.5872 37.5853C39.7356 37.679 39.8879 37.7533 40.0442 37.808V37.8548H36.6575C36.634 37.7064 36.5559 37.5111 36.4231 37.2689C36.2981 37.0189 36.1497 36.7728 35.9778 36.5306L31.8293 30.683C31.6497 30.6986 31.47 30.7142 31.2903 30.7298C31.1106 30.7376 30.927 30.7415 30.7395 30.7415C30.5208 30.7415 30.2981 30.7337 30.0715 30.7181C29.8528 30.7025 29.6301 30.6751 29.4036 30.6361V33.2728ZM29.4036 29.722C29.6145 29.7689 29.8293 29.804 30.0481 29.8275C30.2668 29.8431 30.4778 29.8509 30.6809 29.8509C31.2668 29.8509 31.802 29.765 32.2864 29.5931C32.7708 29.4134 33.1809 29.1439 33.5168 28.7845C33.8606 28.4251 34.1262 27.9798 34.3137 27.4486C34.5012 26.9095 34.595 26.2806 34.595 25.5619C34.595 24.9759 34.5286 24.4447 34.3958 23.9681C34.2629 23.4915 34.0637 23.0892 33.7981 22.7611C33.5403 22.4251 33.2122 22.1673 32.8137 21.9876C32.4153 21.8001 31.9504 21.7064 31.4192 21.7064C30.8801 21.7064 30.4504 21.7337 30.1301 21.7884C29.8098 21.8431 29.5676 21.9017 29.4036 21.9642V29.722Z",
    fill: "#ECE6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.353 47.7589L13.8084 48.3233C15.5812 50.5203 18.8377 50.7716 20.9266 48.8726V48.8726L20.9894 48.8082C22.3957 47.3677 22.3676 45.0597 20.9266 43.6539V43.6539",
    stroke: "#ECE6D6",
    strokeWidth: 1.27287,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04517 35.706L8.25318 36.5181C8.85965 38.8859 11.3757 40.2147 13.6732 39.3805V39.3805L14.1314 39.1856C15.4886 38.6084 16.2008 37.1085 15.7903 35.6919V35.6919",
    stroke: "#ECE6D6",
    strokeWidth: 1.14558,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45996 20.8847L9.07139 21.6276C7.93848 23.7934 8.9201 26.4641 11.186 27.3807V27.3807L11.657 27.5423C13.0519 28.021 14.5847 27.3824 15.227 26.0547V26.0547",
    stroke: "#ECE6D6",
    strokeWidth: 1.01829,
    strokeLinecap: "square"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.6524,
    cy: 42.3807,
    r: 1.75019,
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0222,
    cy: 33.6313,
    r: 1.59108,
    transform: "rotate(-6.2364 15.0222 33.6313)",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8752,
    cy: 24.0957,
    r: 1.43197,
    transform: "rotate(35.7435 15.8752 24.0957)",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1818 15.6134C22.2786 16.3097 21.7926 16.9527 21.0964 17.0495C20.4001 17.1463 19.7571 16.6603 19.6603 15.9641C19.5635 15.2678 20.0494 14.6248 20.7457 14.528C21.442 14.4312 22.0849 14.9171 22.1818 15.6134Z",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6214 10.6114C23.6776 11.3122 23.1551 11.9258 22.4543 11.982C21.7536 12.0382 21.14 11.5156 21.0838 10.8149C21.0276 10.1142 21.5501 9.50057 22.2508 9.44438C22.9516 9.38819 23.5652 9.91069 23.6214 10.6114Z",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2698,
    cy: 45.7538,
    r: 1.75019,
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.70599,
    cy: 33.4701,
    r: 1.59108,
    transform: "rotate(-6.2364 7.70599 33.4701)",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5593,
    cy: 19.1438,
    r: 1.43197,
    transform: "rotate(35.7435 10.5593 19.1438)",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8419,
    cy: 11.4076,
    r: 1.27287,
    transform: "rotate(-7.91672 16.8419 11.4076)",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2235 51.4571C27.8466 51.7043 27.729 52.6625 27.0357 52.692C26.0827 52.7326 23.0681 50.8334 22.2262 50.2827C18.5879 47.9028 15.3943 44.7059 13.2385 40.9155C11.2201 37.3665 10.0071 33.106 10.3499 29.0008C10.8933 22.4939 15.9379 15.4898 20.7771 11.3145C21.1745 10.9716 21.8629 11.4728 21.5298 11.8959C21.1372 12.3946 21.0183 12.5005 20.5433 12.9779C19.7118 13.8133 18.6877 14.7906 17.9301 15.6936C15.3332 18.7888 13.013 22.343 11.9343 26.2739C9.00151 36.962 17.7343 47.6917 27.2235 51.4571Z",
    fill: "#ECE6D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4107 12.6673V12.6673C14.0577 13.9493 13.898 16.0486 15.0417 17.5205L15.0966 17.5911C15.2031 17.7282 15.3211 17.8559 15.4492 17.973V17.973C16.785 19.193 18.8818 18.994 19.9643 17.5447L20.2996 17.0958",
    stroke: "#ECE6D6",
    strokeWidth: 0.891006,
    strokeLinecap: "square"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.9093,
    cy: 1.9093,
    r: 1.59108,
    transform: "matrix(-0.994082 -0.108631 -0.108631 0.994082 58.4607 31.7794)",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7083 47.7585L50.2528 48.3229C48.4801 50.5199 45.2236 50.7712 43.1347 48.8723V48.8723L43.0718 48.8079C41.6656 47.3673 41.6937 45.0594 43.1347 43.6535V43.6535",
    stroke: "#ECE6D6",
    strokeWidth: 1.27287,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0144 35.7059L55.8064 36.518C55.1999 38.8858 52.6839 40.2146 50.3864 39.3804V39.3804L49.9281 39.1855C48.5709 38.6083 47.8587 37.1083 48.2693 35.6918V35.6918",
    stroke: "#ECE6D6",
    strokeWidth: 1.14558,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6021 20.8847L54.9906 21.6276C56.1235 23.7934 55.1419 26.4641 52.876 27.3807V27.3807L52.405 27.5423C51.0101 28.021 49.4773 27.3824 48.835 26.0547V26.0547",
    stroke: "#ECE6D6",
    strokeWidth: 1.01829,
    strokeLinecap: "square"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06841,
    cy: 2.06841,
    r: 1.75019,
    transform: "matrix(-1 0 0 1 46.4771 40.3123)",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.9093,
    cy: 1.9093,
    r: 1.59108,
    transform: "matrix(-0.994082 -0.108631 -0.108631 0.994082 51.1443 31.9404)",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.75019,
    cy: 1.75019,
    r: 1.43197,
    transform: "matrix(-0.811641 0.584157 0.584157 0.811641 48.5842 21.6525)",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8802 15.6134C41.7834 16.3097 42.2694 16.9527 42.9657 17.0495C43.6619 17.1463 44.3049 16.6603 44.4017 15.9641C44.4985 15.2678 44.0126 14.6248 43.3163 14.528C42.62 14.4312 41.9771 14.9171 41.8802 15.6134Z",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4402 10.6114C40.384 11.3122 40.9065 11.9258 41.6072 11.982C42.3079 12.0382 42.9216 11.5156 42.9777 10.8149C43.0339 10.1142 42.5114 9.50057 41.8107 9.44438C41.11 9.38819 40.4963 9.91069 40.4402 10.6114Z",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06841,
    cy: 2.06841,
    r: 1.75019,
    transform: "matrix(-1 0 0 1 53.8579 43.6854)",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.75019,
    cy: 1.75019,
    r: 1.43197,
    transform: "matrix(-0.811641 0.584157 0.584157 0.811641 53.8997 16.7009)",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.59108,
    cy: 1.59108,
    r: 1.27287,
    transform: "matrix(-0.990469 -0.137734 -0.137734 0.990469 49.0149 10.0507)",
    stroke: "#ECE6D6",
    strokeWidth: 0.636433
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8378 51.4571C36.2147 51.7043 36.3323 52.6625 37.0255 52.692C37.9786 52.7326 40.9931 50.8334 41.8351 50.2827C45.4733 47.9028 48.667 44.7059 50.8228 40.9155C52.8412 37.3665 54.0542 33.106 53.7113 29.0008C53.1679 22.4939 48.1233 15.4898 43.2842 11.3145C42.8868 10.9716 42.1984 11.4728 42.5315 11.8959C42.9241 12.3946 43.043 12.5005 43.518 12.9779C44.3494 13.8133 45.3736 14.7906 46.1311 15.6936C48.7281 18.7888 51.0483 22.343 52.1269 26.2739C55.0598 36.962 46.327 47.6917 36.8378 51.4571Z",
    fill: "#ECE6D6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6503 12.6672V12.6672C50.0034 13.9492 50.163 16.0485 49.0194 17.5203L48.9645 17.591C48.858 17.728 48.74 17.8558 48.6118 17.9729V17.9729C47.2761 19.1928 45.1793 18.9939 44.0967 17.5446L43.7615 17.0957",
    stroke: "#ECE6D6",
    strokeWidth: 0.891006,
    strokeLinecap: "square"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9079 53.2256C26.9079 52.5113 27.0406 51.8508 27.3061 51.2439C27.5716 50.6308 27.9351 50.0998 28.3965 49.651C28.8643 49.2022 29.4142 48.8513 30.0464 48.5985C30.6785 48.3456 31.358 48.2192 32.085 48.2192C32.7993 48.2192 33.4693 48.3393 34.0951 48.5795C34.7272 48.8134 35.2772 49.1484 35.745 49.5846C36.2127 50.0208 36.5794 50.5518 36.8449 51.1776C37.1167 51.8034 37.2526 52.505 37.2526 53.2825C37.2526 53.9336 37.1388 54.5594 36.9112 55.1599C36.6837 55.7605 36.3486 56.2915 35.9062 56.7529C35.4637 57.2144 34.92 57.5841 34.2753 57.8623C33.6368 58.1341 32.9004 58.27 32.066 58.27C31.358 58.27 30.6911 58.1531 30.0653 57.9192C29.4395 57.6853 28.8927 57.3503 28.425 56.9141C27.9572 56.4779 27.5874 55.9501 27.3156 55.3306C27.0438 54.7048 26.9079 54.0032 26.9079 53.2256ZM32.2841 57.5778C32.7329 57.5778 33.1438 57.4893 33.5167 57.3123C33.896 57.1353 34.2215 56.8793 34.4934 56.5443C34.7652 56.2093 34.9769 55.8016 35.1286 55.3211C35.2804 54.8407 35.3562 54.2971 35.3562 53.6903C35.3562 53.0076 35.2835 52.3754 35.1381 51.7939C34.9927 51.206 34.7747 50.7003 34.4839 50.2768C34.1994 49.8469 33.8391 49.5119 33.4029 49.2717C32.9668 49.0315 32.4579 48.9114 31.8764 48.9114C31.4276 48.9114 31.0167 48.9999 30.6437 49.1769C30.2708 49.3476 29.9452 49.5972 29.6671 49.926C29.3953 50.2547 29.1835 50.6592 29.0318 51.1396C28.8801 51.6137 28.8042 52.1542 28.8042 52.761C28.8042 53.4437 28.8769 54.079 29.0223 54.6669C29.174 55.2548 29.3953 55.7668 29.686 56.203C29.9768 56.6328 30.3371 56.971 30.767 57.2175C31.2031 57.4577 31.7088 57.5778 32.2841 57.5778Z",
    fill: "#ECE6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRome);
export default __webpack_public_path__ + "static/media/ROME.187c0cabdf211ec145468f5bde145def.svg";
export { ForwardRef as ReactComponent };